import React, { useState, useEffect } from "react";
import { useAuth } from "../hooks/useAuth";
import SuperAdminDashboard from "../pages/SuperAdminDashboard";
import TenantsManagementPage from "../pages/TenantsManagementPage";
import UsersManagementPage from "../pages/UsersManagementPage";
import LoginAuditLogsPage from "../pages/LoginAuditLogsPage";
import AiPromptsPage from "../pages/AiPromptsPage";
import Header from "./layout/Header";

const SuperAdminApp = () => {
  const {
    user,
    userRole,
    currentTenant,
    logout,
  } = useAuth();
  const [currentPage, setCurrentPage] = useState("dashboard");

  useEffect(() => {
    setCurrentPage("dashboard");
  }, []);

  const navigate = (page) => setCurrentPage(page);

  return (
    <div className="min-h-screen bg-[var(--ground,#f5f4f1)] font-inter">
      <Header
        tenant={currentTenant || { name: "Super Admin", logo: "" }}
        user={user}
        userRole={userRole}
        onNavigate={navigate}
        currentPage={currentPage}
        primaryTextColor={currentTenant?.primaryTextColor || "text-blue-600"}
        onLogout={logout}
        isSuperAdmin={true}
      />
      <main className="pt-[72px] min-h-screen">
        {(currentPage === "dashboard" || currentPage === "") && (
          <SuperAdminDashboard onNavigate={navigate} />
        )}
        {currentPage === "tenants" && <TenantsManagementPage />}
        {currentPage === "users" && <UsersManagementPage />}
        {currentPage === "ai-prompts" && <AiPromptsPage />}
        {currentPage === "login-audit" && <LoginAuditLogsPage />}
      </main>
    </div>
  );
};

export default SuperAdminApp;
